import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Icon, Avatar, Popover, BackTop, Divider, Badge, Form, Dropdown, Menu, Button } from 'antd';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroller';
import _ from 'lodash';
import qs from 'query-string';
import PubSub from 'pubsub-js';
import ConnectNotification from '../../Components/ConnectNotification/ConnectNotification';
import BackTopIcon from '../../Icons/BackTopIcon';
import SettingsMenu from '../../Components/SettingsMenu/SettingsMenu';
import { getConfiguration } from '../../Components/Collaborators/Collaborators';
import { getPlanDetailsByProductVariantId, getProductVariantsById } from '../../Reducers/AryaPayOrderReducer';
import signOutAction from '../../Actions/AuthActions';
import { BROADCAST_CHANNEL_POST_MESSAGE } from '../../PubSub/EventTypes';
import * as PayOrderActions from '../../Actions/AryaPayOrderActions';
import * as NotificationActions from '../../Actions/NotificationActions';
import * as AryaNotifyActions from '../../Actions/AryaNotifyActions';
import * as ManualSearchActions from '../../Actions/ManualSearchActions';
import * as AryaNotifyActionCreator from '../../Actions/ActionCreators/AryaNotifyActionCreator';
import * as ConnectActions from '../../Actions/ConnectActions';
import * as JobActions from '../../Actions/JobActions';
import * as CandidateActions from '../../Actions/CandidateActions';
import fetchJobSourcingStatsAction from '../../Actions/SourcingStatsActions';
import * as JobStatusActions from '../../Actions/JobStatusActions';
import * as JobCandidatesTabActions from '../../Actions/JobCandidatesTabActions';
import * as ClientActions from '../../Actions/ClientActions';
import * as AddCandidateActions from '../../Actions/AddCandidateActions';
import {
  getConfig,
  getWhiteLabelInformation,
  getFetchUserConfigApiStatus,
  getNavbarRenderFlag,
} from '../../Reducers/ConfigReducer';
import { setupSocketConnections, closeSocketConnection } from '../../Events/SocketConnectionManager';
import ConnectNotificationWrapper from './ConnectNotification';
import Config from '../../Config/Config';
import {
  getConnectNotificationsCount,
  getPersonsById,
  getConversationPersonMapping,
  getNewNotificationsCount,
} from '../../Reducers/ConnectReducer';
import {
  getNotifications,
  getUnviewedNotificationsCount,
  getNotificationsTotalCount,
  getNewNotificationStatus,
  getCurrentPageNotificationCount,
  getCurrentPageConnectNotificationCount,
} from '../../Reducers/AryaNotifyReducer';
import { getCurrentUser, getLoadCurrentUserApiStatus, getCurrentUserDetails } from '../../Reducers/UserSessionReducer';
import { getJobGuidToIdMapping, getJobsById, getJobListTabName } from '../../Reducers/JobReducer';
import { getUsersByGuId, getUsersById, isImpersonatedOrgUpdated } from '../../Reducers/UserReducer';
import { SystemIcon, ConnectNotificationIcon } from '../../Icons/AryaIcons';
import OfferBanner from './OfferBanner';
import './Navbar.scss';
import messages from './messages';
import AryaNotifications from '../../Components/AryaNotifications/AryaNotifications';
import { getFeatureToggleList } from '../../Reducers/FeatureToggleReducer.ts';
import { getTotalJobCount, getSampleCandidatesDisplayFlag, getNonDraftJobCount } from '../../Reducers/JobStatusReducer';
import { getApiStatus } from '../../Reducers/ApiStatusReducer';
import { getUserType, isPulseUser } from '../../Utils/ConfigUtils';
import { getAccountTypes as _fetchAccountTypes } from '../../Actions/OrganizationActions';
import { getMaskingConfig as _fetchMaskingConfig, fetchConfig as _fetchConfig } from '../../Actions/ConfigActions';
import { getAccountType } from '../../Utils/OrganizationUtils';
import { getAccountTypes } from '../../Reducers/OrganizationsReducer';
import DowntimeAnnouncement from '../DowntimeAnnouncement/DowntimeAnnouncement';
import { getLastNotificationIdAndUpdateTime } from '../../Utils/NotificationUtils';
import * as UserActions from '../../Actions/UserActions';
import { userBudgetDataByUserId } from '../../Reducers/BudgetCappingReducer';
import * as budgetCappingActions from '../../Actions/BudgetCappingActions';
import { isCalendarHomePage } from '../../Utils/CalendarUtils';

function getActiveTab(location) {
  const { pathname, search } = location;
  const { isAssigned } = qs.parse(search);
  if (pathname === '/jobs' && isAssigned === 'false') {
    return 'unassignedJobs';
  }
  if (pathname.includes('/jobs') || pathname === '/') {
    return 'jobs';
  }
  if (
    pathname === '/connect' ||
    pathname === '/connect?tab=templates' ||
    pathname === '/connect?tab=conversations' ||
    pathname === '/connect?tab=workflows'
  ) {
    return 'connect';
  }

  if (pathname === '/calendar') {
    return 'more';
  }
  if (pathname === '/candidate') {
    return 'more';
  }
  if (pathname === '/reports') {
    return 'more';
  }
  if (pathname === '/research') {
    return 'more';
  }
  if (pathname === '/help') {
    return 'more';
  }

  if (pathname === '/buy-credit') {
    return 'buyCredits';
  }
  if (pathname.includes('/segments')) {
    return 'segments';
  }
  return null;
}

const mapStateToProps = state => ({
  currentUser: getCurrentUser(state),
  userConfig: getConfig(state) || {},
  notifications: getNotifications(state),
  role: getConfig(state) ? getConfig(state).Role : 'Recruiter',
  connectNotificationsCount: getConnectNotificationsCount(state),
  personsById: getPersonsById(state),
  conversationPersonMapping: getConversationPersonMapping(state),
  newConnectNotificationsCount: getNewNotificationsCount(state),
  connectNotifications: getNotifications(state, 'Connect'),
  connectNotificationsTotalCount: getNotificationsTotalCount(state, 'Connect'),
  connectNotificationsUnviewedCount: getUnviewedNotificationsCount(state, 'Connect'),
  newConnectNotificationStatus: getNewNotificationStatus(state, 'Connect'),
  newAryaNotificationStatus: getNewNotificationStatus(state, 'Arya'),
  aryaNotifications: getNotifications(state, 'Arya'),
  aryaNotificationsTotalCount: getNotificationsTotalCount(state, 'Arya'),
  aryaNotificationsUnviewedCount: getUnviewedNotificationsCount(state, 'Arya'),
  jobGuidToIdMapping: getJobGuidToIdMapping(state),
  jobsById: getJobsById(state),
  userByGuId: getUsersByGuId(state),
  featureToggleList: getFeatureToggleList(state),
  fetchUserConfigApiStatus: getFetchUserConfigApiStatus(state),
  fetchLoadCurrentUserApiStatus: getLoadCurrentUserApiStatus(state),
  whiteLabelInfo: getWhiteLabelInformation(state),
  totalJobCount: getTotalJobCount(state),
  jobListStatus: getApiStatus(state, 'jobListStatus'),
  jobCountByStatusesApiStatus: getApiStatus(state, 'jobCountByStatusesApiStatus'),
  jobListTabName: getJobListTabName(state),
  accountTypes: getAccountTypes(state),
  showSampleCandidates: getSampleCandidatesDisplayFlag(state),
  planDetailsByProductVariantId: getPlanDetailsByProductVariantId(state),
  planDetailsByProductVariantIdApiStatus: getApiStatus(state, 'fetchPlanDetailsByProductVariantIdApiStatus'),
  productVariantsById: getProductVariantsById(state),
  nonDraftJobCount: getNonDraftJobCount(state),
  navbarRenderFlag: getNavbarRenderFlag(state),
  connectNotificationsApiStatus: getApiStatus(state, 'connectNotifications'),
  currentPageNotificationCount: getCurrentPageNotificationCount(state),
  currentPageConnectNotificationCount: getCurrentPageConnectNotificationCount(state),
  usersById: getUsersById(state),
  fetchUserDetailsApiStatus: getApiStatus(state, 'fetchUserDetailsApiStatus'),
  isImpersonatedOrgChanged: isImpersonatedOrgUpdated(state),
  currentUserBudget: userBudgetDataByUserId(state, getCurrentUserDetails(state).Id),
  postCreditsRequestApiStatus: getApiStatus(state, 'jobLevelPostCreditsRequestApiStatus'),
});

const mapDispatchToProps = {
  setMessagePopupVisibility: NotificationActions.setMessagePopupVisibility,
  signOut: signOutAction,
  getPersonDetails: ConnectActions.getPersonDetails,
  updateConnectViewedTime: ConnectActions.updateConnectViewedTime,
  setHelpTabTimesamp: ConnectActions.setHelpTabTimesamp,
  updateNewNotificationStatus: AryaNotifyActions.updateNewNotificationStatus,
  createSocketConnection: setupSocketConnections,
  fetchConnectNofitications: AryaNotifyActions.fetchConnectNofitications,
  fetchAryaNotifications: AryaNotifyActions.fetchAryaNotifications,
  markConnectNotificationsAsViewed: AryaNotifyActions.markConnectNotificationsAsViewed,
  markAryaNotificationsAsViewed: AryaNotifyActions.markAryaNotificationsAsViewed,
  markNotificationAsRead: AryaNotifyActions.markNotificationAsRead,
  markSingleNotificationAsRead: AryaNotifyActions.markSingleNotificationAsRead,
  saveRecentReadNotificationInfo: AryaNotifyActions.saveRecentReadNotificationInfo,
  toggleAddClientDrawer: ClientActions.toggleAddClientDrawer,
  setJobListPageNumber: JobActions.setJobListPageNumber,
  setDefaultHomePageRenderFlag: JobActions.setDefaultHomePageRenderFlag,
  clearSearchAfterList: JobActions.clearSearchAfterList,
  clearCandidateListSearchAfter: CandidateActions.clearCandidateListSearchAfter,
  setCurrentJobStatusId: JobStatusActions.setCurrentJobStatusId,
  setJobListSearchTerm: JobActions.setJobListSearchTerm,
  updateFilterTags: JobActions.updateFilterTags,
  setJobListTabName: JobActions.setJobListTabName,
  fetchJobDetails: JobActions.fetchJobDetails,
  fetchJobSourcingStats: fetchJobSourcingStatsAction,
  fetchOrgActivatedJobsCount: JobActions.fetchOrgActivatedJobsCount,
  setNotificationFetchEnabled: AryaNotifyActionCreator.setNotificationFetchEnabled,
  fetchAccountTypes: _fetchAccountTypes,
  fetchMaskingConfig: _fetchMaskingConfig,
  resetOrderDetails: PayOrderActions.resetOrderDetails,
  resetOrderDetailsWithoutTax: PayOrderActions.resetOrderDetailsWithoutTax,
  fetchPlanDetailsByProductVariantId: PayOrderActions.fetchPlanDetailsByProductVariantId,
  setJobCandidateTabActiveSourceName: JobCandidatesTabActions.setJobCandidateTabActiveSourceName,
  setJobCandidateActiveTab: JobCandidatesTabActions.setJobCandidateTabActiveTab,
  fetchOrgOpenedJobsCount: JobActions.fetchOrgOpenedJobsCount,
  getAdminFeaturetoggles: UserActions.getAdminFeaturetoggles,
  setCurrentMessagePopupInfos: AryaNotifyActions.setCurrentMessagePopupInfos,
  fetchUsersForRecruiterSelect: UserActions.fetchUsersForDropdownLists,
  fetchConfig: _fetchConfig,
  toggleAddCandidateDrawerVisibleStatus: AddCandidateActions.toggleAddCandidateDrawerVisibleStatus,
  resetManualSearchApiStatuses: ManualSearchActions.resetManualSearchApiStatuses,
  fetchUserAvailableBudget: budgetCappingActions.fetchUserAvailableBudget,
  postBudgetCappingRequest: budgetCappingActions.postBudgetCappingRequest,
};

class NavbarContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: null,
      visiblePopover: 'none',
      moreDropdownVisible: false,
      // eslint-disable-next-line react/no-unused-state
      isMyChatsToggleChecked: false,
      isInitialImpersonate: false,
    };
    const { createSocketConnection } = props;
    this.onClickConnectNotificationItem = this.onClickConnectNotificationItem.bind(this);
    this.onClickSystemNotificationItem = this.onClickSystemNotificationItem.bind(this);
    this.handlePopoversVisibility = this.handlePopoversVisibility.bind(this);
    this.stopImpersonation = this.stopImpersonation.bind(this);
    this.goToHome = this.goToHome.bind(this);
    this.goToCalendarHome = this.goToCalendarHome.bind(this);
    this.signout = this.signout.bind(this);
    document.addEventListener('visibilitychange', createSocketConnection, false);
    document.addEventListener('focus', createSocketConnection, false);
    document.addEventListener('blur', createSocketConnection, false);
  }

  static getDerivedStateFromProps(props) {
    const { newConnectNotificationStatus, newAryaNotificationStatus, updateNewNotificationStatus, currentUser } = props;

    // let newNotificationAudio;
    if (
      newConnectNotificationStatus &&
      newConnectNotificationStatus.showNotification &&
      currentUser.sub !== newConnectNotificationStatus.senderId
    ) {
      // TODO: Add mute option, then we can enable tone for notifications
      // newNotificationAudio = new Audio(`${process.env.PUBLIC_URL}/static/Audio/new-notification.wav`);
      // newNotificationAudio.play();
      setTimeout(() => updateNewNotificationStatus(false, 'Connect', null), 2000);
    }

    if (
      newAryaNotificationStatus &&
      newAryaNotificationStatus.showNotification &&
      currentUser.sub !== newAryaNotificationStatus.senderId
    ) {
      // TODO: Add mute option, then we can enable tone for notifications
      // newNotificationAudio = new Audio(`${process.env.PUBLIC_URL}/static/Audio/new-notification.wav`);
      // newNotificationAudio.play();
      setTimeout(() => updateNewNotificationStatus(false, 'Arya', null), 2000);
    }
    return {
      activeTab: getActiveTab(props.location),
    };
  }

  componentDidMount() {
    const {
      userConfig,
      fetchAryaNotifications,
      createSocketConnection,
      location,
      setJobListTabName,
      setNotificationFetchEnabled,
      fetchAccountTypes,
      fetchMaskingConfig,
      fetchPlanDetailsByProductVariantId,
      getAdminFeaturetoggles,
    } = this.props;
    const { pathname, search } = location;
    const { isAssigned, redirectURL, userId, orgId } = qs.parse(search);
    setNotificationFetchEnabled(true);
    fetchAccountTypes();
    fetchMaskingConfig();
    fetchPlanDetailsByProductVariantId();
    getAdminFeaturetoggles();

    if (!userConfig.IsAryaUser) {
      createSocketConnection();
      fetchAryaNotifications();
    }
    if (pathname === '/jobs' && isAssigned === 'false') {
      setJobListTabName('unAssigned');
    }
    if (redirectURL) {
      window.location.href = `${redirectURL}`;
    }
    if (userId && orgId) {
      localStorage.removeItem('ManagementUser');
      localStorage.removeItem('Impersonate');
      localStorage.removeItem('ImpersonatedUser');
    }
  }

  componentDidUpdate(prevProps) {
    const {
      fetchLoadCurrentUserApiStatus,
      currentUser,
      fetchConnectNofitications,
      fetchUserDetailsApiStatus,
      usersById,
      location,
      userConfig,
      fetchUsersForRecruiterSelect,
      userByGuId,
      isImpersonatedOrgChanged,
      onRefresh,
    } = this.props;
    const { isInitialImpersonate } = this.state;
    if (prevProps.fetchLoadCurrentUserApiStatus === 'PENDING' && fetchLoadCurrentUserApiStatus === 'SUCCESS') {
      const userEmail = currentUser?.email;
      const storedStates = JSON.parse(localStorage.getItem('ConnectMyChatsNotificationPreferences')) || [];
      const currentUserState = storedStates.find(state => state.email === userEmail);
      if (currentUserState) {
        // eslint-disable-next-line react/no-unused-state
        this.setState({ isMyChatsToggleChecked: currentUserState.isMyChatsToggleChecked });
        fetchConnectNofitications(undefined, undefined, currentUserState.isMyChatsToggleChecked, true);
      }
      fetchConnectNofitications(undefined, undefined, false, true);
    }

    const queryParams = qs.parse(location.search);
    const { userId, orgId } = queryParams;
    const currentUserOrgId = userByGuId[currentUser.sub]?.OrgId;
    if (currentUserOrgId && orgId && parseInt(orgId, 10) !== currentUserOrgId) {
      if ((userConfig.CanImpersonate || localStorage.getItem('Impersonate')) && !isInitialImpersonate && userId) {
        this.setState({ isInitialImpersonate: true });
        fetchUsersForRecruiterSelect(
          {
            page: 1,
            searchTerm: null,
            listFor: 'RecruiterSelect',
            userIds: [userId],
          },
          orgId
        );
      }
      if (
        (userConfig.CanImpersonate || localStorage.getItem('ManagementUser')) &&
        prevProps.fetchUserDetailsApiStatus === 'PENDING' &&
        fetchUserDetailsApiStatus === 'SUCCESS' &&
        userId &&
        usersById[userId]
      ) {
        if (!localStorage.getItem('ManagementUser')) localStorage.setItem('ManagementUser', currentUser.sub);
        localStorage.setItem('Impersonate', usersById[userId].UserGuid);
        const impersonatedUser = usersById[userId];
        localStorage.setItem('ImpersonatedUser', JSON.stringify(impersonatedUser));
        const eventData = {
          Reload: true,
          OrgId: parseInt(orgId, 10),
        };
        const broadcastNotification = {
          eventType: 'ImpersonationUpdated',
          eventData,
        };
        PubSub.publish(BROADCAST_CHANNEL_POST_MESSAGE, {
          broadcastNotification,
        });
        onRefresh();
      }
    }
    if (
      isImpersonatedOrgChanged &&
      isImpersonatedOrgChanged.isReloadRequired &&
      isImpersonatedOrgChanged.orgId !== currentUserOrgId
    ) {
      window.location.reload();
    }
  }

  getConnectNotificationComponent = () => {
    const {
      connectNotifications,
      fetchConnectNofitications,
      form,
      currentUser,
      jobsById,
      jobGuidToIdMapping,
      currentPageConnectNotificationCount,
      saveRecentReadNotificationInfo,
      setCurrentMessagePopupInfos,
    } = this.props;
    const { Id: lastNotificationId, UpdatedTime: beforeTime } =
      getLastNotificationIdAndUpdateTime(connectNotifications);
    return connectNotifications.length ? (
      <div className="connect-notifications">
        <InfiniteScroll
          useWindow={false}
          initialLoad={false}
          loadMore={() =>
            fetchConnectNofitications(lastNotificationId, beforeTime, form.getFieldValue('ConnectUserCheckbox'))
          }
          hasMore={currentPageConnectNotificationCount === 10}
          loader={
            <div key="loader" style={{ width: '100%', textAlign: 'center', marginTop: '10px' }}>
              <Icon style={{ fontSize: 20 }} type="loading" spin />
            </div>
          }
          threshold={220}
        >
          {connectNotifications.map(connectNotification => {
            const jobGuid = _.get(connectNotification, ['Payload', 'RefId'], undefined);
            return (
              <ConnectNotification
                notification={connectNotification}
                key={connectNotification.Id}
                onClick={this.onClickConnectNotificationItem}
                currentUser={currentUser}
                jobDetails={jobGuid ? _.get(jobsById, [jobGuidToIdMapping[jobGuid]], {}) : {}}
                saveRecentReadNotificationInfo={saveRecentReadNotificationInfo}
                setCurrentMessagePopupInfos={setCurrentMessagePopupInfos}
              />
            );
          })}
        </InfiniteScroll>
      </div>
    ) : (
      <div className="connect-notification-empty">
        <div className="connect-notification-empty-icon-wrapper">
          <ConnectNotificationIcon className="connect-notification-icon" />
        </div>
        <div className="connect-notification-empty-title">No connect notification found</div>
        <div className="connect-notification-empty-description">
          All the replies from the candidates will appear here
        </div>
      </div>
    );
  };

  onClickConnectNotificationItem(conversationId, personId, notificationId, messageType, personNumber, jobId, payload) {
    const {
      setMessagePopupVisibility,
      getPersonDetails,
      history,
      markSingleNotificationAsRead,
      saveRecentReadNotificationInfo,
      markNotificationAsRead,
    } = this.props;
    if (messageType === 'Email' && payload) {
      history.push('/connect?activeTab=email');
      saveRecentReadNotificationInfo('Connect', { notificationId, ...payload });
      markNotificationAsRead({
        Source: 'Connect',
        Types: [messageType],
        RefId: conversationId,
      });
    } else if (messageType === 'ConsentStatus') {
      history.push(`/jobs/${jobId}/candidates?status=connected`);
      markSingleNotificationAsRead(notificationId, {
        Source: 'Connect',
        Types: messageType,
      });
    } else {
      getPersonDetails(personId, conversationId);
      setMessagePopupVisibility(conversationId, personId, true, messageType, personNumber);
    }
    this.setState({
      visiblePopover: 'none',
    });
  }

  async onClickSystemNotificationItem(notification) {
    const {
      history,
      markNotificationAsRead,
      markSingleNotificationAsRead,
      location,
      fetchJobDetails,
      fetchJobSourcingStats,
      featureToggleList,
    } = this.props;
    const isAdvanceSearchV2Enable = featureToggleList?.AdvanceSearchV2?.IsEnabled;
    const notificationPayload = notification.Payload;
    const notificationType = notification.Type;
    const { pathname: currentPath } = location;
    const pathToCandidateList = isAdvanceSearchV2Enable
      ? `/jobs/${notificationPayload.JobId}/candidates?status=ranked`
      : `/jobs/${notificationPayload.JobId}/candidates`;
    const pathToAppliedBucketCandidateList = `/jobs/${notificationPayload.JobId}/candidates?status=applied`;
    const currentLocation = `/segments/${notificationPayload.JobId}/candidates?status=sourced`;
    if (
      notificationType === 'BulkContactFetched' ||
      notificationType === 'Sourcing' ||
      notificationType === 'CandidatesPublished' ||
      notificationType === 'OrderPlaced'
    ) {
      if (pathToCandidateList !== currentPath) {
        if (notificationType === 'CandidatesPublished') {
          await fetchJobDetails(notificationPayload.JobId);
          fetchJobSourcingStats([notificationPayload.JobId]);
        }
        history.push(pathToCandidateList);
      } else history.go(0);
    }
    if (notificationType === 'FindingCandidates') {
      history.push(`/jobs/${notificationPayload.JobId}`);
    }
    if (notificationType === 'JobShare') {
      history.push(`/jobs/${notificationPayload.JobId}`);
    }
    if (notificationType === 'PortalCredentialFailed') {
      history.push(`/settings/app`);
    }
    if (notificationType === 'SegmentShare') {
      if (currentLocation !== currentPath) {
        await fetchJobDetails(notificationPayload.JobId);
        fetchJobSourcingStats([notificationPayload.JobId]);
        history.push(`/segments/${notificationPayload.JobId}/candidates?status=shortlisted`);
      } else history.go(0);
    }
    if (notificationType === 'CandidateAddRequest-Processed') {
      history.push(`/segments/${notificationPayload.JobId}/candidates?status=shortlisted`);
    }
    if (notificationType === 'Scoring' && pathToAppliedBucketCandidateList !== currentPath) {
      history.push(pathToAppliedBucketCandidateList);
    }
    if (notificationType === 'CreditsExhausted') {
      const targetId = 'credits-info';
      history.push(`/settings/admin#${targetId}`);
    }
    if (notificationType === 'ChatMessageReceived') {
      history.push(
        `/jobs/${notificationPayload.JobId}/sourcingsupport?chatId=${notificationPayload.ChatId}&messageId=${notificationPayload.ChatMessage.MessageId}`
      );
    }
    if (notificationType === 'ChatMessageReplyReceived') {
      history.push(
        `/jobs/${notificationPayload.JobId}/sourcingsupport?chatId=${notificationPayload.ChatId}&messageId=${notificationPayload.ParentChatMessage.MessageId}`
      );
    }
    if (notificationType === 'JobUsageBudgetRequestStatus' || notificationType === 'JobUsageBudgetExhausted') {
      history.push(`/jobs/${notificationPayload.BasicJobInfo[0].JobId}`);
    }
    if (notificationType === 'JobUsageCreditRequested' || notificationType === 'UserBudgetCreditRequested') {
      history.push(`/settings/admin`);
    }

    if (notification.RefId) {
      markNotificationAsRead({
        Source: 'Arya',
        RefId: notification.RefId,
        Types: [notificationType],
      });
    } else {
      markSingleNotificationAsRead(notification.Id, {
        Source: 'Arya',
        Types: [notificationType],
      });
    }

    this.setState({
      visiblePopover: 'none',
    });
  }

  goToHome() {
    const {
      history,
      setJobListPageNumber,
      setDefaultHomePageRenderFlag,
      setCurrentJobStatusId,
      clearSearchAfterList,
      clearCandidateListSearchAfter,
      setJobListSearchTerm,
      updateFilterTags,
      jobListTabName,
    } = this.props;
    const pathName = window.location.pathname;
    const jobListRoute = jobListTabName === 'unAssigned' ? '/jobs?isAssigned=false' : '/jobs';
    if (pathName === '/' || pathName === '/jobs') {
      setJobListPageNumber(1);
      setCurrentJobStatusId(undefined);
      clearSearchAfterList();
      clearCandidateListSearchAfter();
      setJobListSearchTerm('', 'job');
      setDefaultHomePageRenderFlag(true);
      updateFilterTags([]);
      history.push('/jobs');
    } else history.push(jobListRoute);
  }

  goToCalendarHome() {
    const { history } = this.props;
    history.push('/');
  }

  getLogoClickHandler = (shouldShowCalendarAsHome, isJobListEnabled) => {
    if (shouldShowCalendarAsHome) {
      return this.goToCalendarHome;
    }
    if (isJobListEnabled) {
      return this.goToHome;
    }
    return () => {};
  };

  handlePopoversVisibility(visible, popoverName) {
    const {
      markConnectNotificationsAsViewed,
      markAryaNotificationsAsViewed,
      fetchUserAvailableBudget,
      featureToggleList,
    } = this.props;
    if (visible) {
      this.setState({
        visiblePopover: popoverName,
      });
      if (popoverName === 'ConnectNotification') markConnectNotificationsAsViewed();
      if (popoverName === 'SystemNotification') markAryaNotificationsAsViewed();
    } else {
      this.setState({
        visiblePopover: 'none',
      });
    }
    if (featureToggleList.UserBudgetCapping?.IsEnabled) {
      fetchUserAvailableBudget();
    }
  }

  signout() {
    const { signOut } = this.props;
    closeSocketConnection();
    signOut();
  }

  // eslint-disable-next-line class-methods-use-this
  stopImpersonation() {
    localStorage.removeItem('ManagementUser');
    localStorage.removeItem('Impersonate');
    localStorage.removeItem('ImpersonatedUser');
    const url = new URL(window.location.href);
    const { searchParams } = url;
    if (searchParams.has('orgId')) {
      searchParams.delete('orgId');
    }
    if (searchParams.has('userId')) {
      searchParams.delete('userId');
    }
    window.history.replaceState({}, '', `${url.pathname}?${searchParams.toString()}`);
    window.location.reload();
  }

  getProductLogo = () => {
    const userType = getUserType();
    return userType === 'pulse' ? (
      <img src={`${process.env.PUBLIC_URL}/static/Images/pulse_text_white_with_arya.svg`} style={{ height: '28px' }} />
    ) : (
      <img src={`${process.env.PUBLIC_URL}/static/Images/aryalogo.svg`} alt="Arya" />
    );
  };

  goToJob = () => {
    const { setJobListPageNumber, setJobListTabName, clearSearchAfterList, clearCandidateListSearchAfter } = this.props;
    const { activeTab } = this.state;
    setJobListTabName('assigned');
    clearSearchAfterList();
    clearCandidateListSearchAfter();
    if (activeTab !== 'jobs') setJobListPageNumber(1);
  };

  goToSegment = () => {
    const { setJobListPageNumber, clearSearchAfterList, clearCandidateListSearchAfter } = this.props;
    const { activeTab } = this.state;
    clearSearchAfterList();
    clearCandidateListSearchAfter();
    if (activeTab !== 'segments') setJobListPageNumber(1);
  };

  handleHelpTabClick = () => {
    const { setHelpTabTimesamp } = this.props;
    setHelpTabTimesamp(new Date());
  };

  handleMoreDropdownClick = () => {
    const { moreDropdownVisible } = this.state;
    const { resetManualSearchApiStatuses, setJobCandidateTabActiveSourceName } = this.props;
    resetManualSearchApiStatuses();
    setJobCandidateTabActiveSourceName({ activeSourceName: 'Internal' });
    this.setState({ moreDropdownVisible: !moreDropdownVisible });
  };

  handleCurrentUserCheckboxClick = checked => {
    const { fetchConnectNofitications, currentUser } = this.props;
    const storedStates = JSON.parse(localStorage.getItem('ConnectMyChatsNotificationPreferences')) || [];
    const currentUserState = storedStates.find(state => state.email === currentUser.email);
    const currentUserStateIndex = storedStates.findIndex(state => state.email === currentUser.email);
    if (currentUserState) {
      storedStates[currentUserStateIndex].isMyChatsToggleChecked = checked;
    } else {
      storedStates.push({
        email: currentUser.email,
        isMyChatsToggleChecked: checked,
      });
    }
    localStorage.setItem('ConnectMyChatsNotificationPreferences', JSON.stringify(storedStates));
    // eslint-disable-next-line react/no-unused-state
    this.setState({ isMyChatsToggleChecked: checked });
    fetchConnectNofitications(undefined, undefined, checked, true);
  };

  openAddCandidateDrawer = e => {
    const { toggleAddCandidateDrawerVisibleStatus } = this.props;
    e.preventDefault();
    e.stopPropagation();
    toggleAddCandidateDrawerVisibleStatus(true);
  };

  render() {
    const { activeTab, visiblePopover } = this.state;
    const {
      currentUser,
      toggleAddClientDrawer,
      setJobListTabName,
      currentUserBudget,
      postBudgetCappingRequest,
      postCreditsRequestApiStatus,
    } = this.props;
    let email;
    let firstName;
    let lastName;
    if (currentUser) {
      // eslint-disable-next-line prefer-destructuring
      email = currentUser.email;
      firstName = currentUser.given_name;
      lastName = currentUser.family_name;
    }
    const {
      aryaNotifications,
      aryaNotificationsTotalCount,
      aryaNotificationsUnviewedCount,
      fetchAryaNotifications,
      // signOut,
      role,
      history,
      newConnectNotificationStatus,
      newAryaNotificationStatus,
      connectNotifications,
      connectNotificationsUnviewedCount,
      userConfig,
      match,
      userByGuId,
      featureToggleList,
      whiteLabelInfo,
      totalJobCount,
      jobListStatus,
      jobCountByStatusesApiStatus,
      fetchOrgActivatedJobsCount,
      fetchUserConfigApiStatus,
      fetchLoadCurrentUserApiStatus,
      accountTypes,
      navbarRenderFlag,
      setJobCandidateTabActiveSourceName,
      setJobCandidateActiveTab,
      fetchOrgOpenedJobsCount,
      connectNotificationsApiStatus,
      location,
      currentPageNotificationCount,
      fetchConnectNofitications,
      setCurrentMessagePopupInfos,
      form,
      jobsById,
      jobGuidToIdMapping,
      currentPageConnectNotificationCount,
      saveRecentReadNotificationInfo,
      markConnectNotificationsAsViewed,
    } = this.props;

    const IsPulsePromotionalOffer = featureToggleList.PulsePromotionalOffer.IsEnabled;
    const IsConnectEnabled = featureToggleList.Connect.IsEnabled;
    const IsCalendarEnabled = featureToggleList.Calendar.IsEnabled;
    const IsCandidateCreationEnabled = featureToggleList.CandidateCreation.IsEnabled;
    const IsNotificationEnabled = featureToggleList.Notification.IsEnabled;
    const isJobListEnabled = featureToggleList.JobList.IsEnabled;
    const isCandidateCRMEnabled = featureToggleList.CandidateCRM.IsEnabled;
    const isKnowledgeBaseEnabled = featureToggleList.KnowledgeBase.IsEnabled;
    const isViewOnlyModeEnabled = featureToggleList.ViewOnlyMode.IsEnabled;
    const isPulse = isPulseUser();
    const IsProfileEnabled = featureToggleList.Profile.IsEnabled;
    const isResearchTabEnabled =
      featureToggleList.SalesDashboardReports.IsEnabled || featureToggleList.CareerProjectionReport.IsEnabled;
    const isReportPortalEnabled = featureToggleList.ReportingPortal.IsEnabled;
    const userType = getUserType();
    if (match.url === '/unauthorized' || !currentUser || !navbarRenderFlag) {
      return null;
    }
    const accountTypeId = userConfig.AccountTypeId;
    const accountType = getAccountType(accountTypeId, accountTypes);

    if (
      ['SUCCESS', 'FAILED'].includes(fetchUserConfigApiStatus) &&
      ['SUCCESS', 'FAILED'].includes(fetchLoadCurrentUserApiStatus) &&
      ((userType === 'non-pulse' && ['aryapulse', 'whitegloveservice'].includes(accountType?.toLowerCase())) ||
        (userType === 'pulse' && !['aryapulse', 'whitegloveservice'].includes(accountType?.toLowerCase())) ||
        (userConfig.IsAryaUser === false && currentUser.profile !== 'Pulse'))
    ) {
      history.push('/unauthorized');
      return null;
    }

    const showConnectNotification =
      newConnectNotificationStatus &&
      newConnectNotificationStatus.showNotification &&
      currentUser.sub !== newConnectNotificationStatus.senderId;

    const showAryaNotification =
      newAryaNotificationStatus &&
      newAryaNotificationStatus.showNotification &&
      currentUser.sub !== newAryaNotificationStatus.senderId &&
      (newAryaNotificationStatus.eventData.Type !== 'SmartAgentCandidatesFound' ||
        !newAryaNotificationStatus.eventData.IsTransient);

    const connectNotificationComponent = this.getConnectNotificationComponent();

    const menu = (
      <>
        <div className="ant-popover-arrow more-arrow-icon"></div>
        <Menu>
            {!isViewOnlyModeEnabled && IsCalendarEnabled && (
            <Menu.Item className="more-dropdown-item">
              <Link to="/calendar" onClick={this.handleMoreDropdownClick}>
                <div className={`more-dropdown-tab-item ${activeTab === 'calendar' && 'active'}`} role="presentation">
                  <FormattedMessage {...messages.calendar} />
                </div>
              </Link>
            </Menu.Item>
          )}
          {IsCandidateCreationEnabled && !isViewOnlyModeEnabled && (
            <Menu.Item className="more-dropdown-item">
              <Link to="/candidate" onClick={this.handleMoreDropdownClick}>
                <div className="more-dropdown-tab-item" role="presentation">
                  <div className="candidate-menu-item">
                    <div>Candidates</div>
                    <Button ghost className="add-candidate-btn" onClick={this.openAddCandidateDrawer}>
                      Add Candidate
                    </Button>
                  </div>
                </div>
              </Link>
            </Menu.Item>
          )}
          {userType !== 'pulse' && isResearchTabEnabled && (
            <Menu.Item className="more-dropdown-item">
              <Link to="/research" onClick={this.handleMoreDropdownClick}>
                <div className={`more-dropdown-tab-item ${activeTab === 'research' && 'active'}`} role="presentation">
                  <FormattedMessage {...messages.research} />
                </div>
              </Link>
            </Menu.Item>
          )}
          {!isViewOnlyModeEnabled && userType !== 'pulse' && isReportPortalEnabled && (
            <Menu.Item className="more-dropdown-item">
              <Link to="/reports" onClick={this.handleMoreDropdownClick}>
                <div className={`more-dropdown-tab-item ${activeTab === 'reports' && 'active'}`} role="presentation">
                  <FormattedMessage {...messages.reports} />
                </div>
              </Link>
            </Menu.Item>
          )}
          {userType !== 'pulse' && isKnowledgeBaseEnabled && (
            <Menu.Item className="more-dropdown-item">
              <Link to="/help" onClick={this.handleMoreDropdownClick}>
                <div
                  onClick={this.handleHelpTabClick}
                  className={`more-dropdown-tab-item ${activeTab === 'help' && 'active'}`}
                  role="presentation"
                >
                  <FormattedMessage {...messages.help} />
                </div>
              </Link>
            </Menu.Item>
          )}
        </Menu>
      </>
    );

    const connectNotificationFooter = connectNotifications.length ? (
      <div>
        <Divider style={{ margin: 0 }} />
        <div className="go-to-connect">
          <Link to="/connect" style={{ color: '#7F8FA5', fontSize: '14px', fontWeight: 'bold' }}>
            Go To Connect
          </Link>
        </div>
      </div>
    ) : null;

    const popoverParams = {
      trigger: 'click',
      placement: 'bottomRight',
      overlayClassName: 'fixed-popover-menu',
    };
    const configuration = getConfiguration([firstName, lastName].join(' '));
    const managementUser = localStorage.getItem('ManagementUser');
    const impersonate = localStorage.getItem('Impersonate');
    let impersonatedUser = localStorage.getItem('ImpersonatedUser');
    impersonatedUser = (impersonatedUser && JSON.parse(impersonatedUser)) || {};
    const client = localStorage.getItem('Client');

    const connectNotificationTitle = (
      <div style={{ display: 'inline-flex', justifyContent: 'space-between' }}>
        <div style={{ maxWidth: 'fit-content', display: 'relative' }}>Connect Notification</div>
        {/* <div style={{ maxWidth: 'fit-content', display: 'relative', marginLeft: '120px' }}>
          {form.getFieldDecorator('ConnectUserCheckbox')(
            <Switch
              onChange={this.handleCurrentUserCheckboxClick}
              size="small"
              loading={connectNotificationsApiStatus === 'INPROGRESS'}
              checked={this.state.isMyChatsToggleChecked}
            />
          )}
          &nbsp; My Chats
          </div> */}
      </div>
    );
    const msp = location.pathname.includes('msp');
    const shouldShowCalendarAsHome = isCalendarHomePage();

    return (
      <div
        id="navbar-wrapper"
        className={msp ? 'vanish' : ''}
        style={{ backgroundColor: `${_.get(whiteLabelInfo, ['NavbarColor'], '#2d2e67')}` }}
      >
        <div className="navbar" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <BackTop style={{ right: '75px', bottom: '38px' }} visibilityHeight={100}>
            <BackTopIcon style={{ transform: 'scale(1.5)' }} />
          </BackTop>
          <div
            className="logo"
            role="presentation"
            onClick={this.getLogoClickHandler(shouldShowCalendarAsHome, isJobListEnabled)}
          >
            {client ? (
              <img src={`${Config.urls.getWhiteLabelResourceUrl(client)}/logo.png`} alt="WhiteLabel" />
            ) : (
              this.getProductLogo()
            )}
          </div>

          <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}>
            {role === 'Service Rep' ? (
              <Link to="/jobs?isAssigned=false" className="navbar-jobs-tab">
                <div
                  className={`navbar-menu-tab-item ${activeTab === 'unassignedJobs' && 'active'}`}
                  role="presentation"
                  onClick={() => setJobListTabName('unAssigned')}
                >
                  <FormattedMessage {...messages.unassignedJobs} />
                  {activeTab === 'unassignedJobs' &&
                  jobListStatus !== 'INPROGRESS' &&
                  jobCountByStatusesApiStatus !== 'INPROGRESS'
                    ? `( ${totalJobCount} )`
                    : null}
                </div>
              </Link>
            ) : null}

            {isJobListEnabled ? (
              <Link
                to="/jobs"
                role="presentation"
                className={role !== 'Service Rep' ? 'navbar-jobs-tab' : null}
                onClick={this.goToJob}
              >
                <div className={`navbar-menu-tab-item ${activeTab === 'jobs' && 'active'}`} role="presentation">
                  <FormattedMessage {...messages.jobs} />
                </div>
              </Link>
            ) : null}
            {!isViewOnlyModeEnabled && (
              <>
                {isCandidateCRMEnabled && !isPulse ? (
                  <Link to="/segments" role="presentation" onClick={this.goToSegment}>
                    <div className={`navbar-menu-tab-item ${activeTab === 'segments' && 'active'}`} role="presentation">
                      <FormattedMessage {...messages.segments} />
                    </div>
                  </Link>
                ) : null}
                {IsConnectEnabled ? (
                  <Link to="/connect">
                    <div className={`navbar-menu-tab-item ${activeTab === 'connect' && 'active'}`} role="presentation">
                      <FormattedMessage {...messages.connect} />
                    </div>
                  </Link>
                ) : null}
              </>
            )}
            {IsCalendarEnabled && !shouldShowCalendarAsHome ? (
              <Dropdown
                overlay={menu}
                overlayClassName="more-dropdown"
                placement="bottomRight"
                visible={this.state.moreDropdownVisible}
                onVisibleChange={visible => this.setState({ moreDropdownVisible: visible })}
              >
                <div className={`navbar-menu-tab-item last ${activeTab === 'more' && 'active'}`} role="presentation">
                  <FormattedMessage {...messages.more} /> <Icon type="down" />
                </div>
              </Dropdown>
            ) : null}

            {/* {userType !== 'pulse' && isResearchTabEnabled ? (
            <Link to="/research">
              <div className={`navbar-menu-tab-item ${activeTab === 'research' && 'active'}`} role="presentation">
                <FormattedMessage {...messages.research} />
              </div>
            </Link>
          ) : null} */}
            {/* {userType !== 'pulse' && isReportPortalEnabled ? (
            <Link to="/reports">
              <div className={`navbar-menu-tab-item ${activeTab === 'reports' && 'active'}`} role="presentation">
                <FormattedMessage {...messages.reports} />
              </div>
            </Link>
          ) : null} */}
            {/* {userType !== 'pulse' && isKnowledgeBaseEnabled ? (
            <Link to="/help">
              <div
                onClick={this.handleHelpTabClick}
                className={`navbar-menu-tab-item last ${activeTab === 'help' && 'active'}`}
                role="presentation"
              >
                <FormattedMessage {...messages.help} />
              </div>
            </Link>
          ) : null} */}
            {!isViewOnlyModeEnabled && (
              <ConnectNotificationWrapper
                visible={visiblePopover === 'ConnectNotification'}
                handlePopoversVisibility={this.handlePopoversVisibility}
                isConnectEnabled={IsConnectEnabled}
                popoverParams={popoverParams}
                connectNotifications={connectNotifications}
                fetchConnectNofitications={fetchConnectNofitications}
                form={form}
                currentUser={currentUser}
                jobsById={jobsById}
                jobGuidToIdMapping={jobGuidToIdMapping}
                currentPageConnectNotificationCount={currentPageConnectNotificationCount}
                saveRecentReadNotificationInfo={saveRecentReadNotificationInfo}
                setCurrentMessagePopupInfos={setCurrentMessagePopupInfos}
                onClickConnectNotificationItem={this.onClickConnectNotificationItem}
                markConnectNotificationsAsViewed={markConnectNotificationsAsViewed}
                connectNotificationsUnviewedCount={connectNotificationsUnviewedCount}
                showConnectNotification={showConnectNotification}
                connectNotificationComponent={connectNotificationComponent}
              />
            )}
            {IsNotificationEnabled ? (
              <Popover
                title={<h3 className="system-notifcation-popup-title">System Notifications</h3>}
                visible={visiblePopover === 'SystemNotification'}
                placement="bottom"
                content={
                  aryaNotifications.length ? (
                    <AryaNotifications
                      aryaNotifications={aryaNotifications}
                      aryaNotificationsTotalCount={aryaNotificationsTotalCount}
                      fetchAryaNotifications={fetchAryaNotifications}
                      onClick={this.onClickSystemNotificationItem}
                      userByGuId={userByGuId}
                      aryaVersion={_.get(userConfig, 'SubscriptionType')}
                      whiteLabelInfo={whiteLabelInfo}
                      setJobCandidateTabActiveSourceName={setJobCandidateTabActiveSourceName}
                      setJobCandidateActiveTab={setJobCandidateActiveTab}
                      currentPageNotificationCount={currentPageNotificationCount}
                      featureToggleList={featureToggleList}
                    />
                  ) : (
                    <div className="system-notification-empty">
                      <div className="system-notification-empty-icon-wrapper">
                        <SystemIcon className="arya-notification-icon" />
                      </div>
                      <div className="system-notification-empty-title">No system notification found</div>
                      <div className="system-notification-empty-description">
                        All system related notifications will appear here
                      </div>
                    </div>
                  )
                }
                {...popoverParams}
                onVisibleChange={visible => this.handlePopoversVisibility(visible, 'SystemNotification')}
              >
                <div>
                  <span className="navbar-menu-item-icon">
                    <span className="badged-icon">
                      <Badge count={aryaNotificationsUnviewedCount} className="arya">
                        <SystemIcon
                          style={{ cursor: 'pointer' }}
                          className={`arya-notification-icon ${showAryaNotification ? 'wiggle' : ''}`}
                        />
                      </Badge>
                    </span>
                  </span>
                </div>
              </Popover>
            ) : null}
            {IsProfileEnabled ? (
              <Popover
                content={
                  <SettingsMenu
                    email={email}
                    firstName={firstName}
                    lastName={lastName}
                    role={role}
                    signOut={this.signout}
                    history={history}
                    hidePopover={() => this.handlePopoversVisibility(false, 'SettingsMenu')}
                    toggleClientAddDrawer={toggleAddClientDrawer}
                    featureToggleList={featureToggleList}
                    visible={visiblePopover === 'SettingsMenu'}
                    fetchOrgActivatedJobsCount={fetchOrgActivatedJobsCount}
                    userConfig={userConfig}
                    fetchOrgOpenedJobsCount={fetchOrgOpenedJobsCount}
                    currentUserBudget={currentUserBudget}
                    postBudgetCappingRequest={postBudgetCappingRequest}
                    postCreditsRequestApiStatus={postCreditsRequestApiStatus}
                  />
                }
                {...popoverParams}
                visible={visiblePopover === 'SettingsMenu'}
                onVisibleChange={visible => this.handlePopoversVisibility(visible, 'SettingsMenu')}
              >
                <div>
                  <span className="navbar-menu-item-icon last">
                    <Avatar style={{ color: '#ffffff', backgroundColor: configuration.color }}>
                      {configuration.text}{' '}
                    </Avatar>
                    <Icon type="down" className="arrow-icon" />
                  </span>
                </div>
              </Popover>
            ) : null}
          </div>
        </div>
        {managementUser && impersonate ? (
          <div className="impersonate-banner">
            <span>{`You are impersonating ${impersonatedUser.FullName} (${impersonatedUser.Email}) of ${impersonatedUser.OrgName} (${impersonatedUser.OrgId})`}</span>
            <Icon type="close-circle" theme="filled" className="stop-impersonation" onClick={this.stopImpersonation} />
          </div>
        ) : null}
        {IsPulsePromotionalOffer && isPulse ? (
          <OfferBanner
            isDisplayIcon={false}
            content={
              <>
                Special Offer: Purchase 1 job credit & get 1 job credit for FREE. Offer valid from Dec 01 - 15, 2022.
                Click &nbsp;
                <a target="blank" href="https://leoforce.com/offer-terms-conditions">
                  here
                </a>
                &nbsp; for more info.
              </>
            }
          />
        ) : null}
        <DowntimeAnnouncement />
      </div>
    );
  }
}
NavbarContainer.propTypes = {
  notifications: PropTypes.arrayOf(PropTypes.shape({})),
};

NavbarContainer.defaultProps = {
  notifications: [],
};

export default withRouter(Form.create()(connect(mapStateToProps, mapDispatchToProps)(NavbarContainer)));
export { NavbarContainer as NavbarContainerWithoutContainer };
